/* eslint-disable no-undef */
import gsap, { CustomEase, ScrollTrigger } from '@ptchr/gsap/all';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

gsap.registerPlugin(CustomEase, ScrollTrigger);
CustomEase.create('simple', '.57, .46, .8, .72')
class Navigation {
	constructor(selector, options) {
		this.navigation = selector;
		this.options = options;

		this.navigationOpen = false;
		this.init();
	}

	init() {
		this.setSelectorClasses();
		this.ui();

		this.scrollTrigger()
		this.onResize()
	}

	setSelectorClasses() {
		this.navigationMain = this.navigation.querySelector('.o-navigation--main');
		this.navigationMobile = this.navigationMain.querySelector('.wrap');
	}

	ui() {
		this.hamburgerBtn = this.navigation.querySelector('.hamburger');
		this.closeBtn = this.navigation.querySelector('.close');
		this.overlay = this.navigation.querySelector('.overlay');

		this.hamburgerBtn.addEventListener('click', () => {
			this.open()
		})

		this.closeBtn.addEventListener('click', () => {
			this.close()
		})

		this.overlay.addEventListener('click', (e) => {
			e.stopPropagation()
			this.close()
		})
	}

	open() {
		this.navigation.classList.add('is-open');
		this.slideInAnimation()
	}

	close() {
		this.navigation.classList.remove('is-open');
		this.slideOutAnimation()
	}

	slideInAnimation() {
		const tl = gsap.timeline();

		tl.set(this.navigationMobile.querySelectorAll('li'), { autoAlpha: 0 })
		tl.to(this.hamburgerBtn, {
			duration: 0.3,
			ease: 'power2.out',
			autoAlpha: 0,
			x: -50
		}, 'init');
		tl.to(this.overlay, {
			duration: 0.3,
			ease: 'power3.in',
			autoAlpha: 1
		}, 'init');
		tl.to(this.navigationMobile, {
			duration: 0.5,
			xPercent: 100,
			onStart: () => {
				disableBodyScroll(this.navigationMobile);
			}
		}, 'init');
		tl.from(this.navigationMobile.querySelectorAll('li'), {
			duration: 0.3,
			autoAlpha: 0,
			y: 20,
			stagger: {
				each: 0.1,
				ease: 'simple'
			}
		})
	}

	slideOutAnimation() {
		const tl = gsap.timeline({
			onComplete: () => {
				this.resetTimeline(tl)
			}
		});
		tl.to(this.navigationMobile, {
			duration: 0.5,
			xPercent: -100,
			onComplete: () => {
				clearAllBodyScrollLocks();
			}
		}, 'end');
		tl.to(this.hamburgerBtn, {
			duration: 0.5,
			ease: 'power3.in',
			x: 0,
			autoAlpha: 1
		}, 'end-=0.25');
		tl.to(this.overlay, {
			duration: 0.3,
			autoAlpha: 0
		}, 'end+=0.2');
	}

	resetTimeline(timeline) {
		timeline.getChildren().forEach(tween => {
			tween.targets().forEach(elements => {
				gsap.set(elements, {
					clearProps: true
				});
			});
		});
	}

	scrollTrigger() {
		gsap.timeline({
			scrollTrigger: {
				trigger: this.navigation.querySelector('.trigger'),
				start: 'bottom',
				end: 'bottom',
				// markers: true,
				// scrub: true,
				onLeave: () => {
					this.navigationMain.setAttribute('data-theme', 'white')
				},
				onLeaveBack: () => {
					this.navigationMain.setAttribute('data-theme', 'transparent')
				}
			}
		});

		ScrollTrigger.refresh()
	}

	onResize() {
		window.addEventListener('resize', () => {
			if(this.navigation.classList.contains('is-open')) {
				this.close()
			}
		})
	}

	/**
	 * Navigation util
	 */

	offset(el) {
		var rect = el.getBoundingClientRect(),
			scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		return rect.top + scrollTop;
	}

	setViewportWidth() {
		return window.innerWidth || document.documentElement.clientWidth;
	}

	getScrollTop() {
		return window.pageYOffset || document.documentElement.scrollTop;
	}
}

window.addEventListener('load', () => {
	const navigationWrapper = document.querySelector('.navigation-wrapper');
	new Navigation(navigationWrapper);
});


// const throttle = (func, limit) => {
// 	let lastFunc
// 	let lastRan
// 	return function () {
// 		const context = this
// 		const args = arguments
// 		if (!lastRan) {
// 			func.apply(context, args)
// 			lastRan = Date.now()
// 		} else {
// 			clearTimeout(lastFunc)
// 			lastFunc = setTimeout(function () {
// 				if ((Date.now() - lastRan) >= limit) {
// 					func.apply(context, args)
// 					lastRan = Date.now()
// 				}
// 			}, limit - (Date.now() - lastRan))
// 		}
// 	}
// }



// WEBPACK FOOTER //
// ./js/modules/core/navigation.js